export default () => ({
  isBusy: false,
  isActive: false,
  priceForPoints: 0,
  pointsBeforePayment: 0,
  wallet: {},
  payload: {},
  accrualLog: [],
})
